module.exports = __webpack_public_path__ + "media/public/img/logo-queensland-tourism-bd942881c4a2c9adc44641643f1a7c6a.jpeg";